module.exports = __webpack_public_path__ + "img/profile-32.e606d214.jpeg";